import React, {createContext, useContext} from 'react';

import {CategoryMeta, Environments, ToolsMeta} from '../utils/services/types';
import useServiceMeta from '../utils/services/useServiceMeta';

import {defaultConfig} from './defaultConfig';
import {AppSwitcherConfigType} from './types';

const wexDomains: Record<Environments, string> = {
    /* eslint-disable i18next/no-literal-string */
    usdevms: 'https://usdevms.adminx.hppipeline.com/',
    usperfms: 'https://usperfms.adminx.hppipeline.com/',
    uspentestms: 'https://uspentestms.adminx.hppipeline.com/',
    usstagingms: 'https://usstagingms.admin.hp.com/',
    usprodms: 'https://admin.hp.com/',

    eudevms: 'https://eudevms.adminx.hppipeline.com/',
    eustagingms: 'https://eustagingms.admin.hp.com/',
    euprodms: 'https://eu.admin.hp.com/',
    /* eslint-enable i18next/no-literal-string */
};

const AppSwitcherConfig = createContext<AppSwitcherConfigType>({} as AppSwitcherConfigType);

export const AppSwitcherConfigProvider = ({
    children,
    config,
}: {
    children: React.ReactNode;
    config?: Partial<AppSwitcherConfigType>;
}) => {
    const serviceMeta = useServiceMeta();

    const contextData = {...defaultConfig, ...config};

    const allServices = Object.values(serviceMeta)
        .map(cat => Object.values(cat) as Array<CategoryMeta | ToolsMeta>)
        .flat()
        .map(cat => cat.services)
        .flat();

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentService = allServices.find(service => service.name === contextData.currentAppId)!;

    return (
        <AppSwitcherConfig.Provider value={{...contextData, currentService, allServices, wexDomains}}>
            {children}
        </AppSwitcherConfig.Provider>
    );
};

export const useAppSwitcherConfig = () => useContext(AppSwitcherConfig);
